import { WagmiProvider, createConfig, http } from "wagmi";
import {
  coinbaseWallet,
  metaMask,
  walletConnect,
  injected,
} from "wagmi/connectors";
import { mainnet } from "wagmi/chains";

import { constants } from "config";

const config = createConfig({
  chains: [mainnet],
  multiInjectedProviderDiscovery: false,
  connectors: [
    metaMask({ enableAnalytics: false }),
    injected({
      target() {
        return {
          name: "OKX Wallet",
          id: "okxWallet",
          provider: window.okxwallet,
        };
      },
    }),
    coinbaseWallet({ appName: "HUG.art" }),
    walletConnect({ projectId: constants.walletConnectProjectId }),
  ],
  transports: {
    [mainnet.id]: http(
      `https://eth-mainnet.g.alchemy.com/v2/${constants.alchemyApiKey}`,
    ),
  },
});

function WalletProvider({ children }: { children: React.ReactNode }) {
  return <WagmiProvider config={config}>{children}</WagmiProvider>;
}

export { WalletProvider };
